import { combineReducers } from 'redux'

const reducers = combineReducers({
  field: () => ({ value: 'Ok!'})
})

export default reducers



// WEBPACK FOOTER //
// ./src/reducers/index.js